import React from 'react';
import OrphanedMediaManager from '@/components/admin/OrphanedMediaManager';

const AdminCleanupPage = () => {

  return <OrphanedMediaManager />;
};

export default AdminCleanupPage;
